import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import Card from './index';

export default function Drag(props) {
  const { id, index } = props;

  return (
    <Draggable draggableId={String(id)} key={id} index={index}>
      {(dragProvided) => (
        <Card
          dragProps={{ ...dragProvided.draggableProps, ...dragProvided.dragHandleProps, ref: dragProvided.innerRef }}
          {...props}
        />
      )}
    </Draggable>
  );
}
